import { Goal, ID } from '@griply/types';

// Resolves a goal's life area, walking up the parent chain when the goal has no direct lifeAreaId.
export const getGoalLifeArea = (
  goal: Goal,
  goals: Goal[],
  visited: Set<ID> = new Set(),
): ID | undefined => {
  if (goal.lifeAreaId || !goal.parentIds?.length) {
    return goal.lifeAreaId ?? undefined;
  }

  if (visited.has(goal.id)) {
    return undefined;
  }
  visited.add(goal.id);

  const parentGoal = goals.find((g) => g.id === goal.parentIds?.[0]);
  return parentGoal ? getGoalLifeArea(parentGoal, goals, visited) : undefined;
};
